module.exports = __webpack_public_path__ + "fonts/FuzzyBubbles-Regular.8194f10.ttf";